import "@fontsource/poppins";
import {useContext} from "react";
import {TokenContext} from "./Context/TokenContext";
import Main from "./Componant/Main";
import {UserProvider} from "./Context/UserContext";

function Init() {
    const {accessToken} = useContext(TokenContext)


    return (
        <>
            {
                accessToken ? (
                    <UserProvider>
                        <Main>
                        </Main>
                    </UserProvider>
                )
                : ( <></>)
            }
        </>

    );
}

export default Init;
